import { useEffect, useState } from 'react'
import axios from '../../axios-instance';

const GooglePay = (props) => {

    const [jwt, setJwt] = useState(null);

    // const saveToPay = (jwToken) => {
    //     window.gapi.savetoandroidpay.render("dom-container", {
    //         "jwt": jwt,
    //         "onsuccess": (data) => successHandler(data),
    //         "onfailure": (err) => failureHandler(err)
    //     })
    // }
    const failureHandler = (err) => {
        console.log('failure', err)
    }
    const successHandler = (data) => {
        console.log('success', data);
        props.onSaveToWallet();
    }

    const postAndroidPass = async () => {
        await axios.post(`/device/${props.device.id}/content/${props.content.id}/androidpass`,
            {
                forward_url_params: props.forwardParams,
            },
            {
                headers: {
                    'x-device-uuid': `${props.device.uuid}`,
                },
            }).then((res) => {           
                setJwt(res.data.jwt.jwt);
                window.gapi.savetoandroidpay.render("dom-container", {
                    "jwt": res.data.jwt.jwt,
                    "onsuccess": successHandler,
                    "onfailure": failureHandler,
                })
            }).catch ((err) => {
                console.log('Error :', err);
            })
    }
        

    useEffect(() => {        
        postAndroidPass();
    }, [])

    // componentDidMount = () => {
    //     window.gapi.savetoandroidpay.render("dom-container", {
    //         "jwt": this.props.jwt,
    //         "onsuccess": this.successHandler,
    //         "onfailure": this.failureHandler,
    //     })
    // }
    // saveToPay = () => {
    //     window.gapi.savetoandroidpay.render("dom-container", {
    //         "jwt": this.props.jwt,
    //         "onsuccess": (data) => this.successHandler(data),
    //         "onfailure": (err) => this.failureHandler(err)
    //     })
    // }
    // failureHandler = (err) => {
    //     console.log('failure', err)
    // }
    // successHandler = (data) => {
    //     console.log('success', data);
    //     this.props.onSaveToWallet();
    // }
    // render() {
    //     return (
    //             <div id="dom-container"></div>
    //     )
    // }

    return (
        <div id="dom-container"></div>
    )
}

export default GooglePay;